import { render, staticRenderFns } from "./ArrowOrange.vue?vue&type=template&id=1ea5304e&scoped=true"
import script from "./ArrowOrange.vue?vue&type=script&lang=js"
export * from "./ArrowOrange.vue?vue&type=script&lang=js"
import style0 from "./ArrowOrange.vue?vue&type=style&index=0&id=1ea5304e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea5304e",
  null
  
)

export default component.exports